<template>
  <div id="app">
    <sHeader v-if="isAuth()">
    </sHeader>
    <sNavBar v-if="isAuth()"></sNavBar>
    <main class="main">
      <router-view/>
    </main>
    <sFooter v-if="isAuth()"/>
  </div>
</template>

<script>
import sHeader from './components/header/header.vue'
import sFooter from './components/footer/footer.vue'
import sNavBar from './components/navbar/navbar.vue'
import { currentUser } from './firebaseConfig'
import firebase from 'firebase'
const fb = require('./firebaseConfig.js')
export default {
  components: {
    sHeader,
    sFooter,
    sNavBar
  },
  name: 'App',
  methods: {
    isAuth() {
      return fb.auth.currentUser
    }
  }
}
</script>

<style>
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.main{
  margin-bottom: 5rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue